import { AuthConstants } from './constants'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { AuthState, AuthAction } from './types'

const persistConfig = {
  key: 'easeon',
  storage,
}

function authLocal(
  state: AuthState = {},
  action: AuthAction
): AuthState {
  switch (action.type) {
    case AuthConstants.SET_AUTH_INFO:
      return {
        ...state,
        ...action.response,
      }
    case AuthConstants.SET_USER_PROFILE:
      return {
        ...state,
        profile: action.response,
      }
    case AuthConstants.UPDATE_USER:
      return {
        ...state,
        user: { ...(state.user || {}), ...action.response } as AuthState['user'],
      }
    case AuthConstants.DELETE_AUTH_INFO: {
      localStorage.removeItem('persist:root')
      localStorage.removeItem('persist:easeon')
      return {}
    }
    default:
      return state
  }
}

export const auth = persistReducer<AuthState, AuthAction>(
  persistConfig,
  authLocal
)
